import { Link } from "react-router-dom";
import { STATUS_META, scoreBand, formatCurrency, formatDate } from "../lib/constants.js";

export default function GrantTable({ grants, onEvaluate }) {
  if (!grants.length) {
    return (
      <div className="card p-10 text-center text-sm text-ink-500">
        No grants match the current filters.
      </div>
    );
  }
  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-ink-200 text-sm">
          <caption className="sr-only">Grant applications and evaluation progress</caption>
          <thead className="bg-ink-50 text-left text-xs uppercase tracking-wide text-ink-500">
            <tr>
              <th scope="col" className="px-4 py-3">Grant</th>
              <th scope="col" className="px-4 py-3">Organization</th>
              <th scope="col" className="px-4 py-3">Requested</th>
              <th scope="col" className="px-4 py-3">Status</th>
              <th scope="col" className="px-4 py-3">Progress</th>
              <th scope="col" className="px-4 py-3">Final Score</th>
              <th scope="col" className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ink-100">
            {grants.map((g) => {
              const status = STATUS_META[g.status] || STATUS_META.pending;
              const progress = STATUS_META[g.evaluationProgress] || STATUS_META.not_started;
              const band = scoreBand(g.weightedAverage);
              return (
                <tr key={g.id} className="hover:bg-ink-50/60">
                  <td className="px-4 py-3">
                    <Link to={`/grants/${g.id}`} className="font-medium text-brand-700 hover:underline">
                      {g.projectTitle}
                    </Link>
                    <p className="text-xs text-ink-400">{g.grantId}</p>
                  </td>
                  <td className="px-4 py-3 text-ink-700">{g.organization}</td>
                  <td className="px-4 py-3 text-ink-700">{formatCurrency(g.requestedBudget)}</td>
                  <td className="px-4 py-3">
                    <span className={`badge ${status.classes}`}>{status.label}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`badge ${progress.classes}`}>{progress.label}</span>
                  </td>
                  <td className={`px-4 py-3 font-semibold ${band.classes}`}>
                    {g.weightedAverage != null ? g.weightedAverage : "—"}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={() => onEvaluate(g)}
                      className="btn-secondary px-3 py-1.5 text-xs"
                    >
                      Evaluate
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
